export const baseURl = process.env.REACT_APP_SERVER_URL;
export const environment = process.env.REACT_APP_ENVIRONMENT;
export const feversion = process.env.REACT_APP_VERSION;
export const hashKey = process.env.REACT_APP_SIG_PAS || "";
export const encryptionKey = process.env.REACT_APP_ENCRYPT_KEY || "password";
export const encryptionPass = process.env.REACT_APP_ENCRYPT_KEY || "password";
export const accountNumber = process.env.REACT_APP_ACCOUNT || "0";
export const customHeaderImage = process.env.REACT_APP_HEADER_IMAGE || "";
export const backendURL = process.env.REACT_APP_BACKEND_URL || "";

export const qaAutomation = JSON.parse(process.env.REACT_QA_AUTOMATION || "{}");
